export enum ServiceEntrySourceTypes {
    Organization = 'organization',
    Shift = 'shift',
    Volunteer = 'volunteer',
    VolunteerEdits = 'volunteerEdits'
}